import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LegendOncall from './LegendOncall.jsx'
import CalendarOncall from './CalendarOncall.jsx'
//import _ from 'lodash'

class OncallComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.oncall.colors) {
      return <div className="row"><div className="col-sm-8"><CalendarOncall oncall={this.props.oncall} setPublicHolidays={this.props.setPublicHolidays}></CalendarOncall></div><div className="col-sm-3 offset-sm-1"><LegendOncall oncall={this.props.oncall}></LegendOncall></div></div>
    }
    return <div></div>
  }
}

OncallComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  oncall: PropTypes.object.isRequired,
  setPublicHolidays: PropTypes.func.isRequired,
}

export default OncallComponent
